<ng-template #illegal>
    <app-page403></app-page403>
</ng-template>

<section *ngIf="!illegalUser; else illegal" class="mb-5">

    <!-- Usage Reports Section -->
    <div class="col-md-11">
        <div class="d-flex justify-content-between align-items-center">
            <h3>Usage Reports</h3>
            <button class="btn btn-outline-primary" (click)="downloadReport()" [disabled]="!reports.length">
                <i class="fa fa-download"></i> Download CSV
            </button>
        </div>
        <div class="row mb-3">
            <div class="col-md-12 d-flex flex-wrap align-items-start">
                <mat-form-field appearance="fill" class="matwidth mr-3">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="reportPicker">
                        <input matStartDate placeholder="Start Date" #reportStartInput>
                        <input matEndDate placeholder="End Date" #reportEndInput>
                    </mat-date-range-input>
                    <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="reportPicker"></mat-datepicker-toggle>
                    <mat-date-range-picker #reportPicker></mat-date-range-picker>
                </mat-form-field>

                <mat-form-field appearance="fill" class="mr-3">
                    <mat-label>Organization</mat-label>
                    <input matInput placeholder="Filter by organization" #reportOrganizationInput>
                </mat-form-field>

                <button class="btn btn-success ml-3"
                        (click)="filterReports(reportStartInput, reportEndInput, reportOrganizationInput)">
                    Submit
                </button>
            </div>
        </div>

        <ng-container *ngIf="reportsLoading">
            <div class="text-center my-4">
                <mat-spinner style="margin: 0 auto" mode="indeterminate" [diameter]="100"></mat-spinner>
            </div>
        </ng-container>

        <div *ngIf="reportsError" class="alert alert-danger">{{ reportsError }}</div>

        <div *ngIf="!reportsLoading">
            <card>
                <div *ngIf="reports.length > 0; else noReports">
                    <table mat-table [dataSource]="reportDataSource" class="mat-elevation-z8" matSort #reportSort="matSort">
                        <ng-container matColumnDef="analysisDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Analysis Date</th>
                            <td mat-cell *matCellDef="let element">{{ element.AnalysisDate }}</td>
                        </ng-container>

                        <ng-container matColumnDef="userId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>User ID</th>
                            <td mat-cell *matCellDef="let element">{{ element.UserId }}</td>
                        </ng-container>

                        <ng-container matColumnDef="analysisId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Analysis ID</th>
                            <td mat-cell *matCellDef="let element">{{ element.AnalysisId }}</td>
                        </ng-container>

                        <ng-container matColumnDef="analysisType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Analysis Type</th>
                            <td mat-cell *matCellDef="let element">{{ element.AnalysisType }}</td>
                        </ng-container>

                        <ng-container matColumnDef="analysisStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Analysis Status</th>
                            <td mat-cell *matCellDef="let element">{{ element.AnalysisStatus }}</td>
                        </ng-container>

                        <ng-container matColumnDef="analysisFilename">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Input Filename</th>
                            <td mat-cell *matCellDef="let element">{{ element.AnalysisFilename }}</td>
                        </ng-container>

                        <ng-container matColumnDef="projectCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Code</th>
                            <td mat-cell *matCellDef="let element">{{ element.ProjectCode }}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="reportColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: reportColumns;"></tr>
                    </table>
                    <mat-paginator #reportPaginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                    <div *ngIf="reportLastKey" class="text-center mt-2">
                        <button class="btn btn-outline-secondary" (click)="loadMoreReports()">Load more results</button>
                    </div>
                </div>
                <ng-template #noReports>
                    <h4>No reports found for selected filters</h4>
                </ng-template>
            </card>
        </div>
    </div>

</section>
